export const PATH_CARTOGRAPHY = "/map";

export const DEFAULT_LATITUDE = 30;
export const DEFAULT_LONGITUDE = 2;
export const DEFAULT_ZOOM = 3;
